import Name from './name'
import Position from './position'
import Description from './description'
import Photo from './photo'

const Card = ({ photo, name, position, description }) => {
  return (
    <div className="relative w-full flex flex-col gap-y-[20px] lg:gap-y-smallDesktop">
      <Photo image={photo} />
      <Name text={name} />
      <Position text={position} />
      <Description description={description} />
    </div>
  )
}

export default Card
